module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.open),
      expression: "open"
    }],
    staticClass: "note"
  }, [_c('span', {
    staticClass: "note_content"
  }, [_vm._v(_vm._s(_vm.message))]), _vm._v(" "), _c('a', {
    staticClass: "btn_close",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.message = ''
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-remove"
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-45df246a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/vue/note.vue
// module id = 96
// module chunks = 0